export const decreaseTagValue = heading => {
  /** If no heading passed return default */
  if (!heading) return { value: 'h3' }
  const size = heading.value[1]
  const tagNumber = parseInt(size, 10) + 1
  // h6 is the max heading size available
  if (size === '6') {
    return heading
  }

  return { value: `h${tagNumber}` }
}
